import * as ambassadorWixStoresCatalogV3Ribbon from './stores-catalog-v3-ribbon-ribbons-v-3.http.js';
import * as ambassadorWixStoresCatalogV3RibbonTypes from './stores-catalog-v3-ribbon-ribbons-v-3.types.js';
import * as ambassadorWixStoresCatalogV3RibbonUniversalTypes from './stores-catalog-v3-ribbon-ribbons-v-3.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createRibbon(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3RibbonUniversalTypes.CreateRibbonRequest,
  ambassadorWixStoresCatalogV3RibbonTypes.CreateRibbonRequest,
  ambassadorWixStoresCatalogV3RibbonUniversalTypes.CreateRibbonResponse,
  ambassadorWixStoresCatalogV3RibbonTypes.CreateRibbonResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Ribbon.createRibbon(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/ribbons',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getRibbon(): __PublicMethodMetaInfo<
  'GET',
  { ribbonId: string },
  ambassadorWixStoresCatalogV3RibbonUniversalTypes.GetRibbonRequest,
  ambassadorWixStoresCatalogV3RibbonTypes.GetRibbonRequest,
  ambassadorWixStoresCatalogV3RibbonUniversalTypes.GetRibbonResponse,
  ambassadorWixStoresCatalogV3RibbonTypes.GetRibbonResponse
> {
  const payload = { ribbonId: ':ribbonId' } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Ribbon.getRibbon(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/ribbons/{ribbonId}',
    pathParams: { ribbonId: 'ribbonId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateRibbon(): __PublicMethodMetaInfo<
  'PATCH',
  { ribbonId: string },
  ambassadorWixStoresCatalogV3RibbonUniversalTypes.UpdateRibbonRequest,
  ambassadorWixStoresCatalogV3RibbonTypes.UpdateRibbonRequest,
  ambassadorWixStoresCatalogV3RibbonUniversalTypes.UpdateRibbonResponse,
  ambassadorWixStoresCatalogV3RibbonTypes.UpdateRibbonResponse
> {
  const payload = { ribbon: { id: ':ribbonId' } } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Ribbon.updateRibbon(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v3/ribbons/{ribbon.id}',
    pathParams: { ribbonId: 'ribbonId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteRibbon(): __PublicMethodMetaInfo<
  'DELETE',
  { ribbonId: string },
  ambassadorWixStoresCatalogV3RibbonUniversalTypes.DeleteRibbonRequest,
  ambassadorWixStoresCatalogV3RibbonTypes.DeleteRibbonRequest,
  ambassadorWixStoresCatalogV3RibbonUniversalTypes.DeleteRibbonResponse,
  ambassadorWixStoresCatalogV3RibbonTypes.DeleteRibbonResponse
> {
  const payload = { ribbonId: ':ribbonId' } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Ribbon.deleteRibbon(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v3/ribbons/{ribbonId}',
    pathParams: { ribbonId: 'ribbonId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryRibbons(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3RibbonUniversalTypes.QueryRibbonsRequest,
  ambassadorWixStoresCatalogV3RibbonTypes.QueryRibbonsRequest,
  ambassadorWixStoresCatalogV3RibbonUniversalTypes.QueryRibbonsResponse,
  ambassadorWixStoresCatalogV3RibbonTypes.QueryRibbonsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Ribbon.queryRibbons(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/ribbons/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateRibbons(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3RibbonUniversalTypes.BulkCreateRibbonsRequest,
  ambassadorWixStoresCatalogV3RibbonTypes.BulkCreateRibbonsRequest,
  ambassadorWixStoresCatalogV3RibbonUniversalTypes.BulkCreateRibbonsResponse,
  ambassadorWixStoresCatalogV3RibbonTypes.BulkCreateRibbonsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Ribbon.bulkCreateRibbons(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/ribbons/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateRibbons(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3RibbonUniversalTypes.BulkUpdateRibbonsRequest,
  ambassadorWixStoresCatalogV3RibbonTypes.BulkUpdateRibbonsRequest,
  ambassadorWixStoresCatalogV3RibbonUniversalTypes.BulkUpdateRibbonsResponse,
  ambassadorWixStoresCatalogV3RibbonTypes.BulkUpdateRibbonsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Ribbon.bulkUpdateRibbons(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/ribbons/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getOrCreateRibbon(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3RibbonUniversalTypes.GetOrCreateRibbonRequest,
  ambassadorWixStoresCatalogV3RibbonTypes.GetOrCreateRibbonRequest,
  ambassadorWixStoresCatalogV3RibbonUniversalTypes.GetOrCreateRibbonResponse,
  ambassadorWixStoresCatalogV3RibbonTypes.GetOrCreateRibbonResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Ribbon.getOrCreateRibbon(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/ribbons/get-or-create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkGetOrCreateRibbons(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3RibbonUniversalTypes.BulkGetOrCreateRibbonsRequest,
  ambassadorWixStoresCatalogV3RibbonTypes.BulkGetOrCreateRibbonsRequest,
  ambassadorWixStoresCatalogV3RibbonUniversalTypes.BulkGetOrCreateRibbonsResponse,
  ambassadorWixStoresCatalogV3RibbonTypes.BulkGetOrCreateRibbonsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Ribbon.bulkGetOrCreateRibbons(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/ribbons/get-or-create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteRibbons(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3RibbonUniversalTypes.BulkDeleteRibbonsRequest,
  ambassadorWixStoresCatalogV3RibbonTypes.BulkDeleteRibbonsRequest,
  ambassadorWixStoresCatalogV3RibbonUniversalTypes.BulkDeleteRibbonsResponse,
  ambassadorWixStoresCatalogV3RibbonTypes.BulkDeleteRibbonsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Ribbon.bulkDeleteRibbons(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/ribbons/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Ribbon as RibbonOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  CreateRibbonRequest as CreateRibbonRequestOriginal,
  CreateRibbonResponse as CreateRibbonResponseOriginal,
  GetRibbonRequest as GetRibbonRequestOriginal,
  RequestedFields as RequestedFieldsOriginal,
  RequestedFieldsWithLiterals as RequestedFieldsWithLiteralsOriginal,
  GetRibbonResponse as GetRibbonResponseOriginal,
  UpdateRibbonRequest as UpdateRibbonRequestOriginal,
  UpdateRibbonResponse as UpdateRibbonResponseOriginal,
  DeleteRibbonRequest as DeleteRibbonRequestOriginal,
  DeleteRibbonResponse as DeleteRibbonResponseOriginal,
  QueryRibbonsRequest as QueryRibbonsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryRibbonsResponse as QueryRibbonsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  BulkCreateRibbonsRequest as BulkCreateRibbonsRequestOriginal,
  BulkCreateRibbonsResponse as BulkCreateRibbonsResponseOriginal,
  V3BulkRibbonResult as V3BulkRibbonResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateRibbonsRequest as BulkUpdateRibbonsRequestOriginal,
  MaskedRibbon as MaskedRibbonOriginal,
  BulkUpdateRibbonsResponse as BulkUpdateRibbonsResponseOriginal,
  GetOrCreateRibbonRequest as GetOrCreateRibbonRequestOriginal,
  GetOrCreateRibbonResponse as GetOrCreateRibbonResponseOriginal,
  BulkGetOrCreateRibbonsRequest as BulkGetOrCreateRibbonsRequestOriginal,
  BulkGetOrCreateRibbonsResponse as BulkGetOrCreateRibbonsResponseOriginal,
  BulkGetOrCreateRibbonsForMigrationRequest as BulkGetOrCreateRibbonsForMigrationRequestOriginal,
  BulkGetOrCreateRibbonsForMigrationResponse as BulkGetOrCreateRibbonsForMigrationResponseOriginal,
  BulkDeleteRibbonsRequest as BulkDeleteRibbonsRequestOriginal,
  BulkDeleteRibbonsResponse as BulkDeleteRibbonsResponseOriginal,
  BulkRibbonResult as BulkRibbonResultOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  RecloneSiteRequest as RecloneSiteRequestOriginal,
  RecloneSiteResponse as RecloneSiteResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './stores-catalog-v3-ribbon-ribbons-v-3.types.js';
